var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHoverWhiteArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.74068 0.14363C7.84254 0.058798 7.97392 0.0178854 8.10593 0.0298867C8.23795 0.0418879 8.35979 0.10582 8.44468 0.20763L11.7777 4.20763C11.8216 4.25781 11.855 4.31626 11.876 4.37955C11.897 4.44283 11.9051 4.50967 11.8998 4.57614C11.8946 4.6426 11.8761 4.70735 11.8455 4.76657C11.8148 4.82578 11.7727 4.87828 11.7215 4.92096C11.6702 4.96364 11.611 4.99565 11.5472 5.0151C11.4835 5.03455 11.4164 5.04105 11.3501 5.03422C11.2838 5.02738 11.2195 5.00736 11.1611 4.97531C11.1026 4.94327 11.0511 4.89986 11.0097 4.84763L7.67668 0.84763C7.59185 0.745772 7.55094 0.614395 7.56294 0.482381C7.57494 0.350367 7.63888 0.228522 7.74068 0.14363Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.74068 8.91153C7.63888 8.82664 7.57494 8.70479 7.56294 8.57278C7.55094 8.44076 7.59185 8.30939 7.67668 8.20753L11.0097 4.20753C11.0511 4.1553 11.1026 4.11189 11.1611 4.07985C11.2195 4.0478 11.2838 4.02778 11.3501 4.02094C11.4164 4.01411 11.4835 4.02061 11.5472 4.04006C11.611 4.05951 11.6702 4.09152 11.7215 4.1342C11.7727 4.17688 11.8148 4.22938 11.8455 4.28859C11.8761 4.34781 11.8946 4.41256 11.8998 4.47902C11.9051 4.54549 11.897 4.61233 11.876 4.67561C11.855 4.7389 11.8216 4.79735 11.7777 4.84753L8.44468 8.84753C8.35979 8.94934 8.23795 9.01327 8.10593 9.02527C7.97392 9.03727 7.84254 8.99636 7.74068 8.91153Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.394 4.52759C11.394 4.6602 11.3414 4.78737 11.2476 4.88114C11.1538 4.97491 11.0267 5.02759 10.894 5.02759L1.39404 5.02759C1.26143 5.02759 1.13426 4.97491 1.04049 4.88114C0.946721 4.78737 0.894043 4.6602 0.894043 4.52759C0.894043 4.39498 0.946721 4.2678 1.04049 4.17403C1.13426 4.08027 1.26143 4.02759 1.39404 4.02759L10.894 4.02759C11.0267 4.02759 11.1538 4.08027 11.2476 4.17403C11.3414 4.2678 11.394 4.39498 11.394 4.52759Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoverWhiteArrow);
export default __webpack_public_path__ + "static/media/hover_white_arrow.8141193c39d4cb8186a65bdc96efdb8a.svg";
export { ForwardRef as ReactComponent };